// extracted by mini-css-extract-plugin
export default {"strength_chart":"styles_strength_chart__mhuLW","strength_chart-mini":"styles_strength_chart-mini__tYpUA","title-mini":"styles_title-mini__XwQ+8","wrapper":"styles_wrapper__OCyQh"};